module.exports = __webpack_public_path__ + "img/20.cb9798c4.jpg";